import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="pos--fix --spacing5 --size-XL" type={"SiteHeader"} item={{"color":"rgba(0,0,0,1)","colorHover":"rgba(0,0,0,0.5)","className":"fs--18 w--600"}} fixed={true} items={[{"id":"bl0704mpn6u4","use":"page","name":"Fotogalerie","page":"/fotogalerie"},{"id":"434h6j2fqsv8","use":"page","name":"Ceník","page":"/cenik"},{"id":"gc5jt435fo8","use":"page","name":"Kontakt","page":"/kontakt"}]} title={{"color":"rgba(0,0,0,1)","content":"Petr Domanický","className":"fs--24 w--600"}} backgroundColor={"rgba(255,255,255,1)"} button={{"className":"btn-box"}} />
)
}